import * as React from 'react';

var _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgGasPumpSolid = function SvgGasPumpSolid(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M8.235 2a2.706 2.706 0 0 1 2.706 2.706v4.567h1.435c1.007 0 1.823.817 1.823 1.824v4.197c0 .455.37.823.824.823h.27a.823.823 0 0 0 .824-.823v-5.27a2.3 2.3 0 0 1-.382.035 2.265 2.265 0 0 1-1.1-4.245L12.3 3.63l-.068-.07a.941.941 0 0 1 1.279-1.368l.074.063 3.278 3.065a3.6 3.6 0 0 1 1.072 1.94c.041.172.066.35.066.535q-.002.023-.003.047.002.05.003.1v7.353A2.706 2.706 0 0 1 15.294 18h-.27a2.706 2.706 0 0 1-2.707-2.706v-4.139h-1.376v5.904c0 .52-.421.941-.941.941H2.941A.94.94 0 0 1 2 17.059V4.706A2.706 2.706 0 0 1 4.706 2zM4.353 8.588a.47.47 0 0 0 0 .941h4.235a.47.47 0 0 0 0-.941zm11.382-1.176a.382.382 0 1 0 .377.434 2 2 0 0 0-.02-.185.38.38 0 0 0-.357-.249"
    })));
};

export { SvgGasPumpSolid as ReactComponent };
//# sourceMappingURL=GasPumpSolid.svg.es.js.map
